<template>
    <div>
        <el-dialog
            :visible.sync="dialogFormVisible"
            :append-to-body="true"
            width="99%"
            :center="true"
            top="10px"
            :close-on-click-modal="false"
            :before-close="() => closeRecordEdit()"
        >
            <el-descriptions
                direction="vertical"
                :column="4"
                :labelStyle="{'text-align':'center','width':'25%'}"
                :contentStyle="{'text-align': 'center'}"
                :colon="false"
                border
            >
                <el-descriptions-item>
                    <template slot="label">
                        <span>对局类型</span>
                    </template>
                    <div>{{ DetailData.type }}</div>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span>对局规则</span>
                    </template>
                    <div v-for="item in DetailData.rule" :key="item.code" :label="item.name" :value="item.name">
                        <el-tooltip effect="light" :content="item.content" placement="right" style="cursor: help;">
                            <span v-if="item.type === 1" style="color: #CE0000;font-weight: bold;">{{ item.name }}</span>
                            <span v-else-if="item.type === 2" style="color: #D9B300;font-weight: bold;">{{ item.name }}</span>
                            <span v-else-if="item.type === 3" style="color: #0080FF;font-weight: bold;">{{ item.name }}</span>
                            <span v-else-if="item.type === 4" style="color: #00A600;font-weight: bold;">{{ item.name }}</span>
                        </el-tooltip>
                    </div>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span>对局人数</span>
                    </template>
                    <div>{{ DetailData.user_num+'人' }}</div>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span>对局时间</span>
                    </template>
                    <div>{{ DetailData.time }}</div>
                </el-descriptions-item>
            </el-descriptions>
            <el-descriptions
                :column="1"
                :labelStyle="{'text-align':'center','background-color':'#FFFFFF','width':'30px'}"
                :contentStyle="{'text-align': 'center','background-color':'#FFFFFF'}"
                :colon="false"
                border
            >
                <el-descriptions-item>
                    <template slot="label">
                        <div><img :src="$store.state.baseURL+'icon/shengli.png'" height="50px"></div>
                    </template>
                    <el-descriptions
                        direction="vertical"
                        :column="DetailData.detail.win.length"
                        :labelStyle="{'text-align':'center','background-color':'#FFFFFF'}"
                        :contentStyle="{'text-align': 'center','background-color':'#FFFFFF','padding':'0','min-width':'150px'}"
                        :colon="false"
                        border
                    >
                        <el-descriptions-item v-for="item in DetailData.detail.win" :key="item.name">
                            <template slot="label">
                                <el-image
                                    style="height: 160px;border-radius: 10px;"
                                    :src="item.picture" 
                                >
                                    <template slot="placeholder">
                                        <img
                                            style="height: 160px;border-radius: 10px;"
                                            src="../../../assets/img/login_avatar.gif"
                                        />
                                    </template> 
                                </el-image>
                            </template>
                            <div v-if="item.role_gender === 1">
                                <el-row>
                                    <el-col :span="12" style="text-align: right;font-weight: bold;">角色名称&nbsp;</el-col>
                                    <el-col :span="12" style="text-align: left;">
                                        <img :src="$store.state.baseURL+'icon/xingbienan.png'" height="10px"><span style="color: #2894FF;">{{ item.role }}</span>
                                    </el-col>
                                </el-row>
                            </div>
                            <div v-else-if="item.role_gender === 2">
                                <el-row>
                                    <el-col :span="12" style="text-align: right;font-weight: bold;">角色名称&nbsp;</el-col>
                                    <el-col :span="12" style="text-align: left;">
                                        <img :src="$store.state.baseURL+'icon/xingbienv.png'" height="10px"><span style="color: #FF60AF;">{{ item.role }}</span>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-row>
                                <el-col :span="12" style="text-align: right;font-weight: bold;">玩家昵称&nbsp;</el-col>
                                <el-col :span="12" style="text-align: left;">
                                    <span style="color: #921AFF;">{{ item.name }}</span>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12" style="text-align: right;font-weight: bold;">玩家阵营&nbsp;</el-col>
                                <el-col :span="12" style="text-align: left;">
                                    <el-tag v-if="item.group === '军情'" effect="plain" size="mini">{{ item.group }}</el-tag>
                                    <el-tag v-else-if="item.group === '潜伏'" type="danger" effect="plain" size="mini">{{ item.group }}</el-tag>
                                    <el-tag v-else type="success" effect="plain" size="mini">{{ item.group }}</el-tag>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12" style="text-align: right;font-weight: bold;">玩家战况&nbsp;</el-col>
                                <el-col :span="12" style="text-align: left;">
                                    <el-tag style="margin-left: 2px;" v-if="item.isDeclare === 1" type="danger" size="mini">宣胜</el-tag>
                                    <el-tag style="margin-left: 2px;" v-if="item.isAssist === 1" type="success" size="mini">助攻</el-tag>
                                    <el-tag style="margin-left: 2px;" v-if="(item.isDeclare === 0) && (item.isAssist === 0)" size="mini">躺赢</el-tag>
                                    <el-tag style="margin-left: 2px;" v-if="(item.is_dead === '死亡') && (item.murder === item.name)" type="danger" effect="dark" size="mini">自杀</el-tag>
                                    <el-tooltip effect="light" :content="'凶手：'+item.murder" placement="right" style="cursor: help;" v-else-if="(item.is_dead === '死亡') && (item.murder !== item.name)">
                                        <el-tag style="margin-left: 2px;"  type="info" effect="dark" size="mini">死亡</el-tag>
                                    </el-tooltip>  
                                    <el-tag style="margin-left: 2px;" v-else-if="item.is_dead === '败露'" type="warning" effect="dark" size="mini">败露</el-tag>
                                </el-col>
                            </el-row>
                            <!-- <el-row v-if="(item.is_dead === '死亡') && (item.murder !== item.name)">
                                <el-col :span="12" style="text-align: right;font-weight: bold;">凶手&nbsp;</el-col>
                                <el-col :span="12" style="text-align: left;">
                                    <span style="color: #FF0000;">{{ item.murder }}</span>
                                </el-col>
                            </el-row> -->
                            <el-row>
                                <el-col :span="12" style="text-align: right;font-weight: bold;">最后情报&nbsp;</el-col>
                                <el-col :span="12" style="text-align: left;">
                                    <el-tag style="margin-left: 2px;" type="danger" effect="dark" size="mini" @click="ShowLastInfo(item.infocards.red,item.role)">
                                        <span style="font-family: HarmonyOS_Sans_Black;cursor: pointer;">{{ item.infocards.red.length }}</span>
                                    </el-tag>
                                    <el-tag style="margin-left: 2px;" effect="dark" size="mini" @click="ShowLastInfo(item.infocards.blue,item.role)">
                                        <span style="font-family: HarmonyOS_Sans_Black;cursor: pointer;">{{ item.infocards.blue.length }}</span>
                                    </el-tag>
                                    <el-tag style="margin-left: 2px;" type="info" effect="dark" size="mini" @click="ShowLastInfo(item.infocards.black,item.role)">
                                        <span style="font-family: HarmonyOS_Sans_Black;cursor: pointer;">{{ item.infocards.black.length }}</span>
                                    </el-tag>
                                </el-col>
                            </el-row>
                            <el-row v-if="$_has('最后手牌查看')">
                                <el-col :span="12" style="text-align: right;font-weight: bold;">最后手牌&nbsp;</el-col>
                                <el-col :span="12" style="text-align: left;">
                                    <img
                                        :src="$store.state.baseURL+'icon/chakanzuihoukapai.png'"
                                        height="15px"
                                        @click="ShowLastCard(item)"
                                        style="cursor: pointer;margin-top:5px;"
                                    />
                                    <el-dialog
                                        :visible.sync="CardDialogVisible"
                                        :append-to-body="true"
                                        :center="true"
                                        top="100px"
                                        width="680px"
                                        :close-on-click-modal="false"
                                        :before-close="() => CloseCardDialog()"
                                    >
                                        <div style="text-align: center;font-weight: bold;font-size:20px;margin-bottom: 10px;">{{ com_title }}</div>
                                        <div style="width: 100%;text-align: center;">
                                            <span v-for="(win_item,win_index) in CardDate" :key="win_index">
                                                <el-image
                                                    style="height: 160px;border-radius: 10px;margin:5px;"
                                                    :src="win_item.picture" 
                                                >
                                                    <template slot="placeholder">
                                                        <img
                                                            style="height: 160px;border-radius: 10px;"
                                                            src="https://b.fengshenghmd.cn/picture/202311/wmLAppNxjOCs3uSj.png"
                                                        />
                                                    </template> 
                                                </el-image>
                                            </span>
                                        </div>
                                    </el-dialog>
                                </el-col>
                            </el-row>
                        </el-descriptions-item>
                    </el-descriptions>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <div><img :src="$store.state.baseURL+'icon/shibai.png'" height="50px"></div>
                    </template>
                    <el-descriptions
                        direction="vertical"
                        :column="DetailData.detail.lose.length"
                        :labelStyle="{'text-align':'center','background-color':'#FFFFFF'}"
                        :contentStyle="{'text-align': 'center','background-color':'#FFFFFF','padding':'0','min-width':'150px'}"
                        :colon="false"
                        border
                    >
                        <el-descriptions-item v-for="item in DetailData.detail.lose" :key="item.name">
                            <template slot="label">
                                <img :src="item.picture" height="160px" alt="" style="border-radius: 10px;">
                            </template>
                            <div v-if="item.role_gender === 1">
                                <el-row>
                                    <el-col :span="12" style="text-align: right;font-weight: bold;">角色名称&nbsp;</el-col>
                                    <el-col :span="12" style="text-align: left;">
                                        <img :src="$store.state.baseURL+'icon/xingbienan.png'" height="10px"><span style="color: #2894FF;">{{ item.role }}</span>
                                    </el-col>
                                </el-row>
                            </div>
                            <div v-else-if="item.role_gender === 2">
                                <el-row>
                                    <el-col :span="12" style="text-align: right;font-weight: bold;">角色名称&nbsp;</el-col>
                                    <el-col :span="12" style="text-align: left;">
                                        <img :src="$store.state.baseURL+'icon/xingbienv.png'" height="10px"><span style="color: #FF60AF;">{{ item.role }}</span>
                                    </el-col>
                                </el-row>
                            </div>
                            <el-row>
                                <el-col :span="12" style="text-align: right;font-weight: bold;">玩家昵称&nbsp;</el-col>
                                <el-col :span="12" style="text-align: left;">
                                    <span style="color: #921AFF;">{{ item.name }}</span>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12" style="text-align: right;font-weight: bold;">玩家阵营&nbsp;</el-col>
                                <el-col :span="12" style="text-align: left;">
                                    <el-tag v-if="item.group === '军情'" effect="plain" size="mini">{{ item.group }}</el-tag>
                                    <el-tag v-else-if="item.group === '潜伏'" type="danger" effect="plain" size="mini">{{ item.group }}</el-tag>
                                    <el-tag v-else  type="success" effect="plain" size="mini">{{ item.group }}</el-tag>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12" style="text-align: right;font-weight: bold;">玩家战况&nbsp;</el-col>
                                <el-col :span="12" style="text-align: left;">
                                    <el-tag style="margin-left: 2px;" v-if="item.isDeclare === 1" type="danger" size="mini">宣胜</el-tag>
                                    <el-tag style="margin-left: 2px;" v-if="item.isAssist === 1" type="warning" size="mini">演员</el-tag>
                                    <el-tag style="margin-left: 2px;" v-if="(item.isDeclare === 0) && (item.isAssist === 0)" type="info" size="mini">陪玩</el-tag>
                                    <el-tag style="margin-left: 2px;" v-if="(item.is_dead === '死亡') && (item.murder === item.name)" type="danger" effect="dark" size="mini">自杀</el-tag>
                                    <el-tooltip effect="light" :content="'凶手：'+item.murder" placement="right" style="cursor: help;" v-else-if="(item.is_dead === '死亡') && (item.murder !== item.name)">
                                        <el-tag style="margin-left: 2px;"  type="info" effect="dark" size="mini">死亡</el-tag>
                                    </el-tooltip>  
                                    <el-tag style="margin-left: 2px;" v-else-if="item.is_dead === '败露'" type="warning" effect="dark" size="mini">败露</el-tag>
                                </el-col>
                            </el-row>
                            <!-- <el-row v-if="(item.is_dead === '死亡') && (item.murder !== item.name)">
                                <el-col :span="12" style="text-align: right;font-weight: bold;">凶手&nbsp;</el-col>
                                <el-col :span="12" style="text-align: left;">
                                    <span style="color: #FF0000;">{{ item.murder }}</span>
                                </el-col>
                            </el-row> -->
                            <el-row>
                                <el-col :span="12" style="text-align: right;font-weight: bold;">最后情报&nbsp;</el-col>
                                <el-col :span="12" style="text-align: left;">
                                    <el-tag style="margin-left: 2px;" type="danger" effect="dark" size="mini" @click="ShowLastInfo(item.infocards.red,item.role)">
                                        <span style="font-family: HarmonyOS_Sans_Black;cursor: pointer;">{{ item.infocards.red.length }}</span>
                                    </el-tag>
                                    <el-tag style="margin-left: 2px;" effect="dark" size="mini" @click="ShowLastInfo(item.infocards.blue,item.role)">
                                        <span style="font-family: HarmonyOS_Sans_Black;cursor: pointer;">{{ item.infocards.blue.length }}</span>
                                    </el-tag>
                                    <el-tag style="margin-left: 2px;" type="info" effect="dark" size="mini" @click="ShowLastInfo(item.infocards.black,item.role)">
                                        <span style="font-family: HarmonyOS_Sans_Black;cursor: pointer;">{{ item.infocards.black.length }}</span>
                                    </el-tag>
                                </el-col>
                            </el-row>
                            <el-row v-if="$_has('最后手牌查看')">
                                <el-col :span="12" style="text-align: right;font-weight: bold;">最后手牌&nbsp;</el-col>
                                <el-col :span="12" style="text-align: left;">
                                    <img
                                        :src="$store.state.baseURL+'icon/chakanzuihoukapai.png'"
                                        height="15px"
                                        @click="ShowLastCard(item)"
                                        style="cursor: pointer;margin-top:5px;"
                                    />
                                    <el-dialog
                                        :visible.sync="CardDialogVisible"
                                        :append-to-body="true"
                                        :center="true"
                                        top="100px"
                                        width="680px"
                                        :close-on-click-modal="false"
                                        :before-close="() => CloseCardDialog()"
                                    >
                                        <div style="text-align: center;font-weight: bold;font-size:20px;margin-bottom: 10px;">{{ com_title }}</div>
                                        <div style="width: 100%;text-align: center;">
                                            <span v-for="(lose_item,lose_index) in CardDate" :key="lose_index">
                                                <el-image
                                                    style="height: 160px;border-radius: 10px;margin:5px;"
                                                    :src="lose_item.picture" 
                                                >
                                                    <template slot="placeholder">
                                                        <img
                                                            style="height: 160px;border-radius: 10px;"
                                                            src="https://b.fengshenghmd.cn/picture/202311/wmLAppNxjOCs3uSj.png"
                                                        />
                                                    </template> 
                                                </el-image>
                                            </span>
                                        </div>
                                    </el-dialog>
                                </el-col>
                            </el-row>
                        </el-descriptions-item>
                    </el-descriptions>
                </el-descriptions-item>
            </el-descriptions>
        </el-dialog>
    </div>
</template>

<script>
import { GameRecordLastCardRequest } from '@/network/query/GameRecord.js'

export default {
    name:'GameRecordEditComponent',
    data(){
        return {
            CardDate: [],
            CardDialogVisible: false,
            click_role: '',
            com_title: ''
        }
    },
    computed:{},
    methods:{
        ShowLastInfo(arr,role) {
            this.CardDate = arr
            this.click_role = role
            this.com_title = '【'+this.click_role+'】的最后情报'
            
            if(arr.length >0) {
                this.ShowCardDialog()
            }
        },
        ShowLastCard(item) {
            this.loading = true
            this.click_role = item.role
            this.com_title = '【'+this.click_role+'】的最后手牌'
            
            GameRecordLastCardRequest({time: this.DetailData.time,name:item.name})
                .then((s) => {
                    this.loading = false
                    if (s.status === 0) {
                        this.CardDate = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.loading = false
                    this.$message.error(err)
                })
                .finally(()=>{
                        if(this.CardDate.length > 0) {
                            this.ShowCardDialog()
                        } else {
                            alert("【"+item.role+"】已经没有手牌了，值得表扬！")
                        }
                    }
                )
        },
        closeRecordEdit() {
            this.CardDate = []
            this.click_role = ''
            this.$emit('exitGameRecordEditDialog')
        },
        ShowCardDialog() {
            this.CardDialogVisible = true
        },
        CloseCardDialog() {
            this.CardDialogVisible = false
            this.CardDate = []
            this.click_role = ''
            this.com_title = ''
        }
    },
    filters:{},
    props:{
        dialogFormVisible: {
            type: Boolean,
            default() {
                return false
            }
        },
        DetailData: {
            type: Object,
            default() {
                return {
                    detail: {
                        win: [],
                        lose: []
                    }
                }
            }
        }
    },
    created(){},
    beforeDestroy(){},
    mounted(){},
    updated(){},
    components:{},
    watch:{}
}
</script>

<style lang='less' scoped>
.win {
    font-size: 50px;
    color: #FF0000;
}
.lose {
    font-size: 50px;
    color: #000000;
}
</style>